<template>
    <div v-if="Object.keys(options).length" class="filter-status filter">
        <button class="filter-btn icon-caret-down" :class="{ open: open }" @click="toggleFilter()">{{ getLabel }} <span v-if="getLabelNumber" class="number">+ {{ getLabelNumber }}</span> </button>
        <div class="toggle-popup" :class="{ open: open }">
            <div v-if="description" class="filter__header">
                <label>{{ description }}</label>
            </div>
            <div class="filter__body">
                <div class="filter-field filter-field__checkbox" v-for="(option, value) in options">
                    <input type="checkbox" v-model="input" :id="value" :name="name + '[]'" :value="value">
                    <label :for="value">{{ option }}</label>
                </div>
            </div>
            <div class="filter__footer">
                <button @click="clearFilter()" class="delete-filter">Wissen</button>
                <button @click="setFilter()" class="submit-filter">Toepassen</button>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        props: {
            value: {
                type: Array,
                default: () => []
            },
            name: {
                type: String,
                default: ''
            },
            label: {
                type: String,
                default: ''
            },
            description: {
                type: String,
                default: ''
            },
            options:{
                type: Object,
                default: ()=> {

                }
            },
            open: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                input: this.value
            }
        },
        computed: {
            // When the filter is set, show the values otherwise show the default label
            getLabel () {
                let label = ''
                if(this.input.length === 0) {
                    return this.label
                }
                if(!this.longNames){
                    label =  ' ' + this.label.toLowerCase()
                }
                return this.input[0] + label
            },
            getLabelNumber () {

                var length = this.input.length - 1;

                if(this.input.length <= 1) {
                    return null;
                }

                return length
            },
            longNames () {
                return Object.values(this.options)[0].length > 4
            }
        },

        watch: {
            // every time the value (v-model) changes, update the internal input value so we know what happens
            value (val) {
                this.input = val
            },
            // make sure the v-model gets updated
            input(val) {
                this.$emit('input', val);
            }
        },

        methods: {
            // toggle the visibility of the filter
            toggleFilter(){
                if(this.open){
                    this.$parent.hideFilter()
                } else {
                    this.$parent.showFilter(this.name)
                }
            },
            hideFilter () {
                this.$parent.hideFilter()
            },
            setFilter() {
                this.$parent.setFilters()
                this.toggleFilter()
            },
            clearFilter () {
                this.input = []
                this.toggleFilter()
            }
        }
    }
</script>
